export const translations = {
  de: {
    nav: {
      services: "Leistungen",
      strengths: "Stärken",
      reviews: "Bewertungen",
      contact: "Kontakt",
      cta: "Angebot anfordern",
    },
    hero: {
      badge: "5.0 Sterne Qualität · Penzberg & Umgebung",
      title1: "Saubere Räume.",
      title2: "Zuverlässige Objekte.",
      title3: "Ihr Partner ZEMKA.",
      subtitle:
        "Premium Gebäudereinigung für Hausverwaltungen, Gewerbe und Privatkunden in Penzberg. Zügig, gründlich und nachweislich flexibel.",
      ctaPrimary: "Jetzt Angebot anfordern",
      ctaSecondary: "Anrufen: 0170 8251779",
      stat1: "5.0",
      stat1Label: "Google Sterne",
      stat2: "2024",
      stat2Label: "In Penzberg gegründet",
      stat3: "Mo–Sa",
      stat3Label: "07:00 – 18:00 Uhr",
    },
    strengths: {
      eyebrow: "Warum ZEMKA",
      title: "Drei Gründe, warum Hausverwaltungen uns wählen",
      subtitle:
        "Wir kombinieren handwerkliche Präzision mit unternehmerischer Verlässlichkeit – das spüren Sie ab dem ersten Einsatz.",
      items: [
        {
          title: "5.0 Sterne Qualität",
          desc: "Konstant exzellente Bewertungen unserer Kunden. Wir liefern Reinigungsergebnisse, die man sieht – und Standards, die bleiben.",
        },
        {
          title: "Flexibel & Zuverlässig",
          desc: "Kurzfristige Termine, geänderte Reinigungspläne, saisonale Spitzen – wir reagieren schnell und halten zu, was wir versprechen.",
        },
        {
          title: "Erfahrung mit Hausverwaltungen",
          desc: "Langjährige Partnerschaften mit Hausverwaltungen in der Region. Klare Kommunikation, dokumentierte Leistungen, faire Verträge.",
        },
      ],
    },
    services: {
      eyebrow: "Unsere Leistungen",
      title: "Reinigung & Hausmeisterservice aus einer Hand",
      subtitle:
        "Vom Bürogebäude über die Eigentümergemeinschaft bis zur Praxis: ZEMKA übernimmt die regelmäßige Pflege, die anspruchsvolle Grundreinigung und den kompletten Hausmeisterservice.",
      learnMore: "Mehr erfahren",
      items: [
        {
          key: "office",
          title: "Unterhaltsreinigung & Büroreinigung",
          desc: "Tägliche, wöchentliche oder bedarfsgerechte Reinigung von Büros, Arbeitsplätzen, Sanitäranlagen und Verkehrsflächen. Hygienisch, diskret und nach Plan.",
          bullets: [
            "Schreibtische, Bildschirme & Tastaturen",
            "Staubwischen aller Flächen, Regale, Fensterbänke",
            "Böden saugen, wischen & polieren",
            "Sanitär: WC, Waschbecken, Spiegel, Fliesen desinfiziert",
            "Küchen & Teeküchen außen",
            "Müllentsorgung & Verbrauchsmaterial (Seife, Papier)",
            "Türklinken & Lichtschalter desinfiziert",
            "Eingang, Aufzüge & Treppen",
          ],
        },
        {
          key: "deep",
          title: "Grundreinigung & Tiefenreinigung",
          desc: "Intensive Reinigung von Böden, Fugen, Polstern und Glasflächen. Ideal bei Umzug, nach Renovierung oder als jährliche Tiefenpflege.",
          bullets: [
            "Maschinelle Tiefenreinigung von Hartböden",
            "Versiegelung & Beschichtung von Böden",
            "Teppich-Sprühextraktion & Polsterreinigung",
            "Fenster- & Glasreinigung innen und außen",
            "Fugenreinigung in Bad & Küche",
            "Heizkörper, Lampen, Türrahmen, Sockelleisten",
            "Bauendreinigung nach Renovierung",
            "Entkalkung von Armaturen & Sanitärobjekten",
          ],
        },
        {
          key: "standard",
          title: "Standardreinigung",
          desc: "Klar strukturierte, planbare Reinigungsleistungen für Treppenhäuser, Gemeinschaftsflächen und Privathaushalte – pünktlich und sorgfältig.",
          bullets: [
            "Treppenhausreinigung in Mehrfamilienhäusern",
            "Eingang, Briefkastenanlage & Aufzug",
            "Privathaushaltsreinigung (regelmäßig oder einmalig)",
            "Fenster innen (bei Erreichbarkeit)",
            "Keller-, Trocken- & Waschräume",
            "Geländer & Handläufe desinfiziert",
            "Spinnweben & Staub von Lampen entfernen",
            "Bedarfsgerechte Reinigungsintervalle",
          ],
        },
        {
          key: "caretaker",
          title: "Hausmeisterservice & Objektbetreuung",
          desc: "Komplette Objektbetreuung: Gartenpflege, Außenanlagen, Winterdienst, Kleinreparaturen und Wartung – ein verlässlicher Ansprechpartner für Ihr Objekt.",
          bullets: [
            "Gartenpflege: Rasen mähen, Hecken schneiden, Unkraut",
            "Außenanlagen: Wege fegen, Laub entfernen",
            "Winterdienst: Schneeräumung & Streuen",
            "Kleinreparaturen: Glühbirnen, Dichtungen, Silikon",
            "Wartung & Sichtkontrolle (Heizung, Schlösser)",
            "Mülltonnen-Bereitstellung & Rücknahme",
            "Begehung mit Mängelprotokoll",
            "Pflege von Briefkasten- & Klingelanlagen",
          ],
        },
      ],
    },
    testimonials: {
      eyebrow: "Google Bewertungen · 5,0 ★",
      title: "Echte Stimmen unserer Kunden",
      subtitle: "Originale Bewertungen von Hausverwaltungen, Unternehmen und Privatkunden – nachzulesen auf Google.",
      items: [
        {
          quote:
            "Sehr professionelle Reinigungsfirma. Auch kurzfristige Änderungen wurden flexibel und zuverlässig umgesetzt. Die Arbeiten wurden zügig, gründlich und zu meiner vollsten Zufriedenheit ausgeführt. Freundliches und kompetentes Team. Sehr empfehlenswert.",
          name: "Svetlana Spasic",
          role: "Google Bewertung",
        },
        {
          quote:
            "Wir arbeiten als Hausverwaltung regelmäßig mit der ZEMKA Gebäudereinigung & Hausmeister Service in Penzberg zusammen und sind sehr zufrieden. Die Arbeiten werden stets zuverlässig, sauber und mit viel Engagement ausgeführt.",
          name: "Valeriya",
          role: "Hausverwaltung · Google Bewertung",
        },
        {
          quote:
            "Top Service. Immer motiviert und freundlich. Preis-Leistung sehr gut. Wir sind rundum zufrieden und können dieses Unternehmen empfehlen.",
          name: "Michael Weber",
          role: "Google Bewertung",
        },
        {
          quote:
            "Können wir nur weiterempfehlen! Sauberkeit wird bei diesem Service groß geschrieben. Auf besondere Wünsche wird auch eingegangen. Top!",
          name: "Mosaic",
          role: "Gewerbekunde · Google Bewertung",
        },
        {
          quote:
            "Sehr freundlich und professionell. Top Preis-Leistungs-Verhältnis.",
          name: "Besmir Vejseli",
          role: "Google Bewertung",
        },
        {
          quote:
            "5 Sterne für ZEMKA – ohne wenn und aber weiterzuempfehlen.",
          name: "Flamur Munishi",
          role: "Google Bewertung",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Sprechen Sie mit uns – wir antworten zügig.",
      subtitle:
        "Direkter Draht zu ZEMKA – wir sind in Penzberg und Umgebung für Sie unterwegs. Rufen Sie an, schreiben Sie eine E-Mail oder kommen Sie vorbei.",
      info: {
        callTitle: "Direkt anrufen",
        callSub: "Mo – Sa, 07:00 – 18:00 Uhr",
        addressTitle: "Adresse",
        address: "Sigmundstraße\n82377 Penzberg, Deutschland",
        hoursTitle: "Öffnungszeiten",
        hoursMonSat: "Montag – Samstag",
        hoursMonSatVal: "07:00 – 18:00",
        hoursSun: "Sonntag",
        hoursSunVal: "Geschlossen",
      },
    },
    footer: {
      tagline: "Premium Gebäudereinigung & Hausmeisterservice – Penzberg & Umgebung.",
      rights: "Alle Rechte vorbehalten.",
      legal: "Impressum",
      privacy: "Datenschutz",
    },
    stickyCta: "Jetzt anrufen",
  },
  en: {
    nav: {
      services: "Services",
      strengths: "Strengths",
      reviews: "Reviews",
      contact: "Contact",
      cta: "Request quote",
    },
    hero: {
      badge: "5.0 Star Quality · Penzberg & Region",
      title1: "Spotless spaces.",
      title2: "Reliable buildings.",
      title3: "Your partner ZEMKA.",
      subtitle:
        "Premium building cleaning and caretaker services for property managers, commercial clients and private households in Penzberg. Fast, thorough and remarkably flexible.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "Call: 0170 8251779",
      stat1: "5.0",
      stat1Label: "Google rating",
      stat2: "2024",
      stat2Label: "Founded in Penzberg",
      stat3: "Mon–Sat",
      stat3Label: "07:00 – 18:00",
    },
    strengths: {
      eyebrow: "Why ZEMKA",
      title: "Three reasons property managers choose us",
      subtitle:
        "We combine craftsmanship and entrepreneurial reliability – you feel it from the very first job.",
      items: [
        {
          title: "5.0 Star Quality",
          desc: "Consistently excellent customer reviews. Visible results and standards that stay in place – not just for the first week.",
        },
        {
          title: "Flexible & Reliable",
          desc: "Short notice jobs, changing schedules, seasonal peaks – we adapt quickly and keep every promise we make.",
        },
        {
          title: "Experience with property managers",
          desc: "Long-term partnerships with property management firms in the region. Clear communication, documented work, fair contracts.",
        },
      ],
    },
    services: {
      eyebrow: "Our services",
      title: "Cleaning & caretaker services from a single source",
      subtitle:
        "From office buildings to homeowner associations and medical practices: ZEMKA handles routine maintenance, demanding deep cleans and complete caretaker services.",
      learnMore: "Learn more",
      items: [
        {
          key: "office",
          title: "Office & workplace cleaning",
          desc: "Daily, weekly or on-demand cleaning of offices, workstations, sanitary facilities and circulation areas. Hygienic, discreet and on schedule.",
          bullets: [
            "Desks, monitors & keyboards",
            "Dusting of shelves, surfaces & window sills",
            "Floor vacuuming, mopping & polishing",
            "Sanitary: toilets, sinks, mirrors, tiles disinfected",
            "Kitchens & break rooms (exterior surfaces)",
            "Waste disposal & supplies (soap, paper)",
            "Door handles & light switches disinfected",
            "Entrances, elevators & stairs",
          ],
        },
        {
          key: "deep",
          title: "Deep & basic cleaning",
          desc: "Intensive cleaning of floors, joints, upholstery and glass surfaces. Perfect after moves, renovations or as annual deep maintenance.",
          bullets: [
            "Machine deep-cleaning of hard floors",
            "Floor sealing & coating",
            "Carpet spray extraction & upholstery cleaning",
            "Window & glass cleaning inside and outside",
            "Joint cleaning in bathrooms & kitchens",
            "Radiators, lamps, door frames & skirtings",
            "Post-construction cleaning",
            "Descaling of taps & sanitary fittings",
          ],
        },
        {
          key: "standard",
          title: "Standard cleaning",
          desc: "Clearly structured, predictable cleaning for stairwells, common areas and private homes – punctual and meticulous.",
          bullets: [
            "Stairwell cleaning in apartment buildings",
            "Entrance, mailbox area & elevator",
            "Private household cleaning (regular or one-off)",
            "Interior windows (where accessible)",
            "Cellars, drying & laundry rooms",
            "Handrails & banisters disinfected",
            "Removal of cobwebs & lamp dust",
            "Tailored cleaning intervals",
          ],
        },
        {
          key: "caretaker",
          title: "Caretaker & facility services",
          desc: "Complete property care: garden & outdoor maintenance, winter service, small repairs and inspections – one reliable contact for your building.",
          bullets: [
            "Garden care: lawn mowing, hedge trimming, weeding",
            "Outdoor areas: paths sweeping, leaf removal",
            "Winter service: snow clearing & gritting",
            "Small repairs: bulbs, seals, silicone work",
            "Inspections (heating, locks, sanitary)",
            "Bin provision & retrieval",
            "Property walkthroughs with defect reports",
            "Care of mailbox & doorbell systems",
          ],
        },
      ],
    },
    testimonials: {
      eyebrow: "Google reviews · 5.0 ★",
      title: "Real voices from our customers",
      subtitle: "Original reviews from property managers, businesses and private clients – verified on Google.",
      items: [
        {
          quote:
            "A very professional cleaning company. Short-notice changes were handled flexibly and reliably. The work was carried out fast, thoroughly and to my complete satisfaction. A friendly and competent team. Highly recommended.",
          name: "Svetlana Spasic",
          role: "Google review",
        },
        {
          quote:
            "As a property management company we work regularly with ZEMKA Gebäudereinigung & Hausmeister Service in Penzberg and we are very satisfied. The work is always reliable, clean and carried out with great dedication.",
          name: "Valeriya",
          role: "Property management · Google review",
        },
        {
          quote:
            "Top service. Always motivated and friendly. Excellent value for money. We are completely satisfied and can recommend this company.",
          name: "Michael Weber",
          role: "Google review",
        },
        {
          quote:
            "We can only recommend them! Cleanliness is taken seriously here, and special requests are accommodated. Top!",
          name: "Mosaic",
          role: "Commercial client · Google review",
        },
        {
          quote:
            "Very friendly and professional. Excellent value for money.",
          name: "Besmir Vejseli",
          role: "Google review",
        },
        {
          quote:
            "5 stars for ZEMKA – recommended without hesitation.",
          name: "Flamur Munishi",
          role: "Google review",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Talk to us – we respond quickly.",
      subtitle:
        "A direct line to ZEMKA – we work across Penzberg and the surrounding region. Give us a call, send an email or stop by.",
      info: {
        callTitle: "Call us directly",
        callSub: "Mon – Sat, 07:00 – 18:00",
        addressTitle: "Address",
        address: "Sigmundstraße\n82377 Penzberg, Germany",
        hoursTitle: "Opening hours",
        hoursMonSat: "Monday – Saturday",
        hoursMonSatVal: "07:00 – 18:00",
        hoursSun: "Sunday",
        hoursSunVal: "Closed",
      },
    },
    footer: {
      tagline: "Premium building cleaning & caretaker services – Penzberg & region.",
      rights: "All rights reserved.",
      legal: "Imprint",
      privacy: "Privacy",
    },
    stickyCta: "Call now",
  },
};
